/** Product performance budgets. Regression tooling and UX instrumentation use
 * the same values so the targets cannot silently drift apart. */
export const PERFORMANCE_TARGETS = {
	navigationFeedbackMs: 100,
	searchP95Ms: 1_000,
	companyCoreP75Ms: 1_500,
} as const;
